import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,name: 'capitalize'})

export class CapitalizePipe implements PipeTransform {
    transform(value: string = ''): string {
        return (value != null) ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : value;
    }
}
